import { createFileRoute } from "@tanstack/react-router";

import { DatasetsPage } from "~/pages/datasets/datasets.page";

export const Route = createFileRoute("/_app/datasets/")({
  component: DatasetsPage,
});
